/**
 * WHAT A ROW OF THE NEEDS-SENDING LIST OFFERS. Pure, so it can be tested. Read from GET /api/admin/invites/needs-sending:
 * see needs_sending in backend/server.py. A lapsed link cannot be sent, so its only action is a re-issue.
 */

export function rowLine(r = {}) {
  if (r.state === "live") return `Never sent. ${r.days_left} ${r.days_left === 1 ? "day" : "days"} left.`;
  return "Never sent, and the link has lapsed.";
}

/** "send", "reissue", or "" when this row cannot be acted on here. */
export function rowAction(r = {}) {
  if (r.state === "live") return "send";
  return r.group && r.first_name && r.last_name ? "reissue" : "";
}

/** Why a lapsed row has no button: a re-issue needs a roster group and a full name. */
export function rowBlocked(r = {}) {
  return rowAction(r) ? "" : "Re-issue it from the Invite a fitter card: this row has no roster group or full name.";
}

export function reissuePayload(r = {}) {
  return { first_name: r.first_name, last_name: r.last_name, email: r.email, company: r.company || "", group: r.group };
}
